import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MatDialogClose, MatButton, TranslatePipe, MatDialogActions, MatDialogContent, MatDialogTitle],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  data: {
    title?: string
    description?: string
    confirmLabel?: string
    cancelLabel?: string
  } = inject(MAT_DIALOG_DATA)
  dialog = inject(MatDialogRef<ConfirmDialogComponent>)

  @HostListener('document:keydown', ['$event'])
  triggerKeys(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeDialog(false)
    }
    if (event.key === 'Enter') {
      this.closeDialog(true)
    }
  }

  closeDialog(afterCloseStatus: boolean): void {
    this.dialog.close(afterCloseStatus)
  }
}
